// This is a modal for Adminmembersone

import { Button as AIMEButton } from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { enterpriceImg, individualImg, InfoCircleIcon } from "./assets";
import { addMembersItem } from "./redux/slices/MembersThunks";
import { isValidEmail, isValidUKPhone } from "./utils/func";

export default function ModalAdminmembersone({ onClose, errorModal }) {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email_address: "",
    phone_number: "",
    job_title: "",
    seniority: "",
    country_of_residence: "",
    password: "",
    member_type: "Individual",
    company_name: "",
    company_website_url: "",
    company_address: "",
    company_no: "",
    tax_identification_no: "",
    is_uk_registered: false,
    unique_taxpayer_reference_utr: "",
    profile_status: "Active",
  });
  const [hasSubmitted, setHasSubmitted] = useState(false);




  const handler = async () => {
    setHasSubmitted(true);
    formData.email_address = formData.email_address?.trim().toLowerCase();
    const isIndividual = formData.member_type === "Individual" ? true : false;

    const missingRequiredFields =
      !formData.first_name ||
      !formData.last_name ||
      !formData.email_address ||
      !formData.seniority ||
      !formData.seniority ||
      !formData.country_of_residence ||
      !isValidEmail(formData.email_address) ||
      !formData.phone_number ||
      !isValidUKPhone(formData.phone_number) ||
      (!isIndividual && (!formData.company_no || !formData.company_no)) ||
      (!isIndividual &&
        (!formData.tax_identification_no || !formData.tax_identification_no)) ||
      (!isIndividual &&
        (!formData.company_name || !formData.company_address)) ||
      (!isIndividual &&
        formData.is_uk_registered &&
        !formData.unique_taxpayer_reference_utr);

    if (missingRequiredFields) {
      console.log(missingRequiredFields);

      return;
    }

    const payload = { ...formData };
    try {
      const res = await dispatch(addMembersItem(payload)).unwrap();
      onClose();
    } catch (error) {
      console.error("Error adding member:", error);
      const errorMessage =
        error?.message ||
        (typeof error === "string" ? error : null) ||
        error?.formData?.message ||
        error?.response?.formData?.message ||
        "Failed to add member. Please try again.";

      if (
        errorMessage.includes("Email already exists") ||
        errorMessage.includes("already exists")
      ) {
        errorModal(); // Show error modal
        onClose();
      } else {
        console.error(error);
      }
    } finally {
      setHasSubmitted(false);
    }
  };

  return (
    <RootWrapperModalAdminmembersone>
      <Section>
        <Wrapper>
          <SignupSignin>
            <Frame58>
              <Frame1410>
                <Frame5>
                  <SelectMemberType>Select member type</SelectMemberType>
                  <TooltipWrapper>
                    <GFeildsInfo src={InfoCircleIcon} alt="icon" />
                    <TooltipText className="tooltip">
                      Select 'Individual Member’ if you would like to be paid
                      your Fixed Referral Rewards straight into your personal
                      bank account. The majority of members will be an
                      ‘individual member’. Select ‘Enterprise member’ if you
                      would like Fixed Referral Rewards to be paid into your
                      company’s bank account e.g. if you are a marketing
                      consultant with a Ltd company.
                    </TooltipText>
                  </TooltipWrapper>
                </Frame5>
                <Frame1412>
                  <SelectionCard
                    onClick={() => {
                      setFormData({ ...formData, member_type: "Individual" });
                    }}
                    style={{
                      border:
                        formData.member_type == "Individual"
                          ? "solid 2px rgb(66, 149, 254)"
                          : "",
                    }}
                  >
                    <HoldingMoney1 />

                    <ReferrerText>Individual</ReferrerText>

                    <SubmitReferralEarn>
                      e.g. Marketing professionals
                    </SubmitReferralEarn>
                  </SelectionCard>
                  <SelectionCard_0001
                    onClick={() => {
                      setFormData({ ...formData, member_type: "Enterprise" });
                    }}
                    style={{
                      border:
                        formData.member_type == "Enterprise"
                          ? "solid 2px rgb(66, 149, 254)"
                          : "",
                    }}
                  >
                    <Image />

                    <ReferrerText>Enterprise</ReferrerText>

                    <SubmitReferralEarn>
                      e.g Marketing consultants with Limited Companies
                    </SubmitReferralEarn>
                  </SelectionCard_0001>
                </Frame1412>
              </Frame1410>
              <Frame1409>
                <PRTNR.Input
                  label="First name"
                  value={formData.first_name}
                  onChange={(e) => {
                    setFormData({ ...formData, first_name: e.target.value });
                  }}
                  required
                  error={hasSubmitted && !formData.first_name}
                  errorMessage={"Required Field"}
                />

                <PRTNR.Input
                  label="Last name"
                  value={formData.last_name}
                  onChange={(e) => {
                    setFormData({ ...formData, last_name: e.target.value });
                  }}
                  required
                  error={hasSubmitted && !formData.last_name}
                  errorMessage={"Required Field"}
                />
              </Frame1409>

              <PRTNR.Input
                label="Email address"
                value={formData.email_address}
                onChange={(e) => {
                  setFormData({ ...formData, email_address: e.target.value });
                }}
                required
                error={
                  hasSubmitted &&
                  (!formData.email_address ||
                    !isValidEmail(formData.email_address))
                }
                errorMessage={
                  !formData.email_address
                    ? "Required Field"
                    : !isValidEmail(formData.email_address)
                    ? "Invalid Email"
                    : ""
                }
              />

              <PRTNR.Input
                label="Phone"
                value={formData.phone_number}
                onChange={(e) => {
                  setFormData({ ...formData, phone_number: e.target.value });
                }}
                required
                error={
                  hasSubmitted &&
                  (!formData.phone_number ||
                    !isValidUKPhone(formData.phone_number))
                }
                errorMessage={
                  !formData.phone_number
                    ? "Required Field"
                    : !isValidUKPhone(formData.phone_number)
                    ? "Enter a valid UK phone number"
                    : ""
                }
              />

              <Frame1409>
                <PRTNR.Input
                  label="Job title"
                  value={formData.job_title}
                  onChange={(e) => {
                    setFormData({ ...formData, job_title: e.target.value });
                  }}
                  required
                  error={hasSubmitted && !formData.job_title}
                  errorMessage={"Required Field"}
                />

                <PRTNR.Select
                  label="Seniority"
                  value={formData.seniority}
                  options={[
                    { value: "C-level", label: "C-level" },
                    { value: "Consultant", label: "Consultant" },
                    { value: "Senior Management", label: "Senior Management" },
                    { value: "Manager", label: "Manager" },
                    { value: "Assistant", label: "Assistant" },
                    {
                      value: "Junior Professional",
                      label: "Junior Professional",
                    },
                  ]}
                  onChange={(e) => {
                    setFormData({ ...formData, seniority: e.target.value });
                  }}
                  required
                  error={hasSubmitted && !formData.seniority}
                  errorMessage={"Required Field"}
                />
              </Frame1409>
              <Frame1409>
                <PRTNR.Select
                  label="Country of residence"
                  value={formData.country_of_residence}
                  options={[
                    { value: "United Kingdom", label: "United Kingdom" },
                  ]}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      country_of_residence: e.target.value,
                    });
                  }}
                  required
                  error={hasSubmitted && !formData.country_of_residence}
                  errorMessage={"Required Field"}
                />
                <PRTNR.Input
                  label="City"
                  value={formData.city}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      city: e.target.value,
                    });
                  }}
                  required
                  error={hasSubmitted && !formData.city}
                  errorMessage={"Required Field"}
                />
              </Frame1409>

              {formData?.member_type == "Enterprise" && (
                <>
                  <Container>
                    <WelcomeJames>Business Information</WelcomeJames>
                  </Container>
                  <PRTNR.Input
                    label="Company name"
                    value={formData.company_name}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        company_name: e.target.value,
                      });
                    }}
                    required
                    error={hasSubmitted && !formData.company_name}
                    errorMessage={"Required Field"}
                  />

                  <PRTNR.Input
                    label="Company website"
                    value={formData.company_website_url}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        company_website_url: e.target.value,
                      });
                    }}
                    required
                    error={hasSubmitted && !formData.company_website_url}
                    errorMessage={"Required Field"}
                  />
                  <PRTNR.Input
                    label="Company address"
                    value={formData.company_address}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        company_address: e.target.value,
                      });
                    }}
                    required
                    error={hasSubmitted && !formData.company_address}
                    errorMessage={"Required Field"}
                  />
                  <Frame1409>
                    <PRTNR.Input
                      label="Company no"
                      value={formData.company_no}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          company_no: e.target.value,
                        });
                      }}
                      required
                      error={hasSubmitted && !formData.company_no}
                      errorMessage={"Required Field"}
                    />

                    <Frame1528>
                      <PRTNR.Input
                        label="VAT number"
                        value={formData.tax_identification_no}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            tax_identification_no: e.target.value,
                          });
                        }}
                      />
                      <TooltipWrapper
                        style={{
                          position: "relative",
                          zIndex: 10000,
                          left: "204px",
                          bottom: "84px",
                        }}
                      >
                        <GFeildsInfo src={InfoCircleIcon} alt="icon" />
                        <TooltipText className="tooltip">lorem</TooltipText>
                      </TooltipWrapper>
                    </Frame1528>
                  </Frame1409>
                  <PRTNR.Select
                    label="Is your company a UK partnership"
                    options={[
                      { value: false, label: "No" },
                      { value: true, label: "Yes" },
                    ]}
                    value={formData.is_uk_registered}
                    onChange={(e) => {
                      if (e.target.value == false) {
                        setFormData({
                          ...formData,
                          unique_taxpayer_reference_utr: "",
                        });
                      }
                      setFormData({
                        ...formData,
                        is_uk_registered: e.target.value,
                      });
                    }}
                  />
                  {formData?.is_uk_registered ? (
                    <PRTNR.Input
                      label="Unique taxpayer reference (UTR)"
                      value={formData.unique_taxpayer_reference_utr}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          unique_taxpayer_reference_utr: e.target.value,
                        });
                      }}
                      required
                      error={hasSubmitted && !formData.seniority}
                      errorMessage={"Required Field"}
                    />
                  ) : (
                    <PRTNR.DisabledInput
                      label="Unique taxpayer reference (UTR)"
                      required
                    />
                  )}
                  <TooltipWrapper
                    style={{
                      position: "relative",
                      left: "12px",
                      bottom: "84px",
                    }}
                  >
                    <GFeildsInfo src={InfoCircleIcon} alt="icon" />
                    <TooltipText className="tooltip">lorem</TooltipText>
                  </TooltipWrapper>
                </>
              )}

              <Frame59>
                <AIMEButton
                  size="small"
                  onClick={() => {
                    handler();
                  }}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    gap: "10px",
                    borderRadius: "48px",
                    width: "320px",
                    background: "rgb(33, 37, 67)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    boxSizing: "border-box",
                    padding: "16px 32px",
                    "&:hover": {
                      background: "rgb(33, 37, 67)",
                      opacity: "0.9",
                    },
                  }}
                >
                  <span
                    style={{
                      color: "white",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "110%",
                      textAlign: "left",
                    }}
                  >
                    Submit
                  </span>
                </AIMEButton>
              </Frame59>
            </Frame58>
          </SignupSignin>
        </Wrapper>
      </Section>
    </RootWrapperModalAdminmembersone>
  );
}

const RootWrapperModalAdminmembersone = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;
`;

const Section = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const SignupSignin = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 16px;
  border: solid 1px rgba(136, 136, 136, 0.1);
  width: 560px;
  padding: 32px;
`;

const Frame1410 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame5 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const SelectMemberType = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const GFeildsInfo = styled.img`
  width: 14px;
  height: 14px;
  object-fit: cover;
`;

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;

  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }
`;

const TooltipText = styled.div`
  visibility: hidden;
  color: #000000;
  font-weight: 500;
  font-size: 12px;
  text-align: start;
  padding: 8px 16px;
  border-radius: 4px;
  position: absolute;
  z-index: 1;
  top: 125%; /* Show below the icon */
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  max-width: 280px;
  width: 280px;
  backdrop-filter: blur(20px);
  background: var(--backgrounds-primary, #ffffff);
  font-family: "Montserrat", sans-serif;
  &::after {
    content: "";
    position: absolute;
    bottom: 100%; /* Top of the tooltip box */
    left: 50%;
    margin-left: -6px;
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent var(--backgrounds-primary, #ffffff)
      transparent;
  }
`;

const Frame1412 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const SelectionCard = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: 1;
  gap: 4px;
  border-radius: 8px;
  align-self: stretch;
  width: 240px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
  cursor: pointer;
`;

const HoldingMoney1 = styled.div`
  width: 80px;
  height: 80px;
  background-image: url(${individualImg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

const ReferrerText = styled.span`
  color: black;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const SubmitReferralEarn = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 14px;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const SelectionCard_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: 1;
  gap: 4px;
  border: solid 1px rgb(224, 228, 244);
  border-radius: 8px;
  width: 240px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  cursor: pointer;
`;

const Image = styled.div`
  width: 80px;
  height: 80px;
  background-image: url(${enterpriceImg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

const Frame1409 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1528 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 16px;
  width: 240px;
  box-sizing: border-box;
`;

const Frame59 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const WelcomeJames = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: flex-start;
`;

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;
